module.exports = __webpack_public_path__ + "img/stone-ditch.0efe0e2c.jpg";